import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnrichedCartItem, OrderBody } from '@oe-backend/types';
import { map } from 'rxjs';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { BaseApiService } from '../../base-api/base-api.service';

export class CartService extends BaseApiService {
	private http = inject(HttpClient);

	fetch(queryParams?: HttpParams) {
		return this.http
			.get<ResponseObjectApiInterface<EnrichedCartItem[]>>(this.apiBaseUrl + '/Cart', {
				params: queryParams ? queryParams : undefined,
			})
			.pipe(map((response: ResponseObjectApiInterface<EnrichedCartItem[]>) => response.data));
	}

	fetchById(id: string) {
		return this.http
			.get<ResponseObjectApiInterface<EnrichedCartItem>>(this.apiBaseUrl + '/Cart/item/' + id)
			.pipe(map((response: ResponseObjectApiInterface<EnrichedCartItem>) => response.data));
	}

	fetchItemCount() {
		return this.http
			.get<ResponseObjectApiInterface<number>>(this.apiBaseUrl + '/Cart/count')
			.pipe(map((response: ResponseObjectApiInterface<number>) => response.data));
	}

	add(item: OrderBody, isReaderOrder: boolean = false) {
		const itemCopy = { ...item };
		if (isReaderOrder) {
			// remove props for reader order
			delete itemCopy.ageGroup;
			delete itemCopy.color;
			delete itemCopy.prescriptions;
			delete itemCopy.personalization;
		}
		return this.http
			.post<
				ResponseObjectApiInterface<EnrichedCartItem[]>
			>(this.apiBaseUrl + '/Cart/item', itemCopy)
			.pipe(map((response: ResponseObjectApiInterface<EnrichedCartItem[]>) => response.data));
	}

	update(id: string, item: OrderBody) {
		return this.http
			.put<
				ResponseObjectApiInterface<EnrichedCartItem[]>
			>(this.apiBaseUrl + '/Cart/item/' + id, item)
			.pipe(map((response: ResponseObjectApiInterface<EnrichedCartItem[]>) => response.data));
	}

	delete(id: string) {
		return this.http
			.delete<ResponseObjectApiInterface<EnrichedCartItem[]>>(this.apiBaseUrl + '/Cart/item/' + id)
			.pipe(map((response: ResponseObjectApiInterface<EnrichedCartItem[]>) => response.data));
	}
}
